(function () {
  'use strict';

  // ponytail: client-side filter only — all manuals resolved from static JSON, no server search.
  var PAGE_SIZE = 12;
  var FEATURED_LIMIT = 6;

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function getData() {
    return window.TCB_MANUAL_FINDER_DATA || {};
  }

  function populateSelect(select, options, placeholder) {
    if (!select) return;
    var html = '<option value="">' + escapeHtml(placeholder) + '</option>';
    options.forEach(function (opt) {
      html +=
        '<option value="' +
        escapeHtml(opt.value) +
        '">' +
        escapeHtml(opt.label) +
        '</option>';
    });
    select.innerHTML = html;
  }

  function getModelsForBrand(brand) {
    var seen = {};
    (getData().manuals || []).forEach(function (manual) {
      if (manual.brand === brand && manual.model) {
        seen[manual.model] = true;
      }
    });
    return Object.keys(seen)
      .sort()
      .map(function (model) {
        return { value: model, label: model };
      });
  }

  function manualHaystack(manual) {
    var parts = [
      manual.title,
      manual.brand,
      manual.model,
      manual.manualLabel,
      manual.equipmentLabel
    ];
    if (Array.isArray(manual.keywords)) {
      parts = parts.concat(manual.keywords);
    }
    return parts.join(' ').toLowerCase();
  }

  function filterManuals(criteria) {
    var manuals = getData().manuals || [];
    return manuals.filter(function (manual) {
      if (criteria.brand && manual.brand !== criteria.brand) return false;
      if (criteria.model && manual.model !== criteria.model) return false;
      if (criteria.manualType && manual.manualType !== criteria.manualType) return false;
      if (criteria.keyword) {
        var query = criteria.keyword.toLowerCase();
        if (manualHaystack(manual).indexOf(query) === -1) return false;
      }
      return true;
    });
  }

  function buildManualActions(manual) {
    var pdfUrl = manual.pdfUrl || manual.downloadUrl || '';
    var requestUrl = manual.requestUrl || '/pages/contact?topic=documents#tcb-contact-form';
    if (pdfUrl) {
      return (
        '<div class="tcb-mf-manual__actions">' +
        '<a class="tcb-mf-btn tcb-mf-btn--link" href="' +
        escapeHtml(pdfUrl) +
        '" target="_blank" rel="noopener noreferrer">View PDF</a>' +
        '<a class="tcb-mf-btn tcb-mf-btn--primary" href="' +
        escapeHtml(pdfUrl) +
        '" download>Download</a>' +
        '</div>'
      );
    }
    return (
      '<div class="tcb-mf-manual__actions">' +
      '<a class="tcb-mf-btn tcb-mf-btn--primary" href="' +
      escapeHtml(requestUrl) +
      '">Request Manual</a>' +
      '</div>'
    );
  }

  function buildManualCard(manual) {
    var meta = [manual.brand, manual.model, manual.equipmentLabel]
      .filter(Boolean)
      .join(' · ');
    return (
      '<article class="tcb-mf-manual">' +
      '<div class="tcb-mf-manual__body">' +
      '<p class="tcb-mf-manual__type">' +
      escapeHtml(manual.manualLabel || manual.manualType) +
      '</p>' +
      '<h3 class="tcb-mf-manual__title">' +
      escapeHtml(manual.title) +
      '</h3>' +
      (meta
        ? '<p class="tcb-mf-manual__meta">' + escapeHtml(meta) + '</p>'
        : '') +
      buildManualActions(manual) +
      '</div></article>'
    );
  }

  function buildFeaturedCard(manual) {
    return (
      '<article class="tcb-mf-featured">' +
      '<div class="tcb-mf-featured__body">' +
      '<p class="tcb-mf-featured__type">' +
      escapeHtml(manual.manualLabel || manual.manualType) +
      '</p>' +
      '<h3 class="tcb-mf-featured__title">' +
      escapeHtml(manual.title) +
      '</h3>' +
      '<p class="tcb-mf-featured__meta">' +
      escapeHtml(manual.brand) +
      (manual.model ? ' · ' + escapeHtml(manual.model) : '') +
      '</p>' +
      buildManualActions(manual) +
      '</div></article>'
    );
  }

  function init(root) {
    var data = getData();
    var brandSelect = root.querySelector('[data-mf-brand]');
    var modelSelect = root.querySelector('[data-mf-model]');
    var typeSelect = root.querySelector('[data-mf-manual-type]');
    var brandForm = root.querySelector('[data-mf-brand-form]');
    var typeForm = root.querySelector('[data-mf-type-form]');
    var keywordForm = root.querySelector('[data-mf-keyword-form]');
    var resultsPanel = root.querySelector('[data-mf-results]');
    var loadMoreBtn = root.querySelector('[data-mf-load-more]');
    var featuredTrack = root.querySelector('[data-mf-featured-track]');
    var featuredNext = root.querySelector('[data-mf-featured-next]');
    var browseBtn = root.querySelector('[data-mf-browse-cats]');
    var searchAnchor =
      root.querySelector('[data-mf-search]') ||
      root.querySelector('[data-mf-brand-form]') ||
      root.querySelector('.tcb-mf-ways');

    var state = {
      filtered: [],
      visibleCount: 0,
      heading: ''
    };

    populateSelect(
      brandSelect,
      (data.brands || []).map(function (brand) {
        return { value: brand, label: brand };
      }),
      'Select brand'
    );

    populateSelect(modelSelect, [], 'Select model');

    populateSelect(
      typeSelect,
      (data.manualTypes || []).map(function (type) {
        return { value: type.id, label: type.label };
      }),
      'Select manual type'
    );

    function syncModelsForBrand(brand) {
      populateSelect(modelSelect, getModelsForBrand(brand), 'Select model');
    }

    if (brandSelect) {
      brandSelect.addEventListener('change', function () {
        syncModelsForBrand(brandSelect.value);
      });
    }

    function hideResults() {
      if (resultsPanel) resultsPanel.hidden = true;
    }

    function updateLoadMore() {
      if (!loadMoreBtn) return;
      var remaining = state.filtered.length - state.visibleCount;
      loadMoreBtn.hidden = remaining <= 0;
      loadMoreBtn.textContent =
        remaining > 0 ? 'Load more (' + remaining + ')' : 'Load more';
    }

    function renderResultsList() {
      if (!resultsPanel) return;
      var grid = resultsPanel.querySelector('[data-mf-results-grid]');
      var titleEl = resultsPanel.querySelector('[data-mf-results-title]');
      var countEl = resultsPanel.querySelector('[data-mf-results-count]');
      var items = state.filtered.slice(0, state.visibleCount);
      var emptyHtml =
        '<p class="tcb-mf-results__empty">No manuals matched your search. Try another brand, model, or keyword.</p>';

      if (titleEl) {
        titleEl.textContent = state.heading || 'Manual results';
      }
      if (countEl) {
        countEl.textContent =
          state.filtered.length > 0
            ? 'Showing ' + items.length + ' of ' + state.filtered.length
            : '';
      }
      if (grid) {
        grid.innerHTML = items.length
          ? items.map(buildManualCard).join('')
          : emptyHtml;
      }

      updateLoadMore();
    }

    function showResults(manuals, heading) {
      state.filtered = manuals;
      state.visibleCount = Math.min(PAGE_SIZE, manuals.length);
      state.heading = heading || '';
      if (resultsPanel) {
        resultsPanel.hidden = false;
        renderResultsList();
        resultsPanel.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    function scrollToSearch() {
      if (searchAnchor) {
        searchAnchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    function manualTypeLabel(typeId) {
      var match = (data.manualTypes || []).find(function (type) {
        return type.id === typeId;
      });
      return (match && match.label) || typeId;
    }

    if (brandForm) {
      brandForm.addEventListener('submit', function (event) {
        event.preventDefault();
        var brand = brandSelect ? brandSelect.value : '';
        var model = modelSelect ? modelSelect.value : '';
        if (!brand) return;
        var manuals = filterManuals({ brand: brand, model: model });
        var heading =
          brand +
          (model ? ' · ' + model : '') +
          ' — ' +
          manuals.length +
          ' manual' +
          (manuals.length === 1 ? '' : 's');
        showResults(manuals, heading);
      });
    }

    if (typeForm) {
      typeForm.addEventListener('submit', function (event) {
        event.preventDefault();
        var formTypeSelect =
          typeForm.querySelector('[data-mf-manual-type]') || typeSelect;
        var manualType = formTypeSelect ? formTypeSelect.value : '';
        if (!manualType) return;
        var manuals = filterManuals({ manualType: manualType });
        showResults(
          manuals,
          manualTypeLabel(manualType) +
            ' — ' +
            manuals.length +
            ' manual' +
            (manuals.length === 1 ? '' : 's')
        );
      });
    }

    if (keywordForm) {
      keywordForm.addEventListener('submit', function (event) {
        event.preventDefault();
        var input =
          keywordForm.querySelector('[data-mf-keyword]') ||
          keywordForm.querySelector('[name="q"]') ||
          keywordForm.querySelector('input[type="search"]') ||
          keywordForm.querySelector('input');
        var keyword = input ? input.value.trim() : '';
        if (!keyword) return;
        var manuals = filterManuals({ keyword: keyword });
        showResults(
          manuals,
          'Results for "' +
            keyword +
            '" — ' +
            manuals.length +
            ' manual' +
            (manuals.length === 1 ? '' : 's')
        );
      });
    }

    if (loadMoreBtn) {
      loadMoreBtn.addEventListener('click', function () {
        state.visibleCount = Math.min(
          state.visibleCount + PAGE_SIZE,
          state.filtered.length
        );
        renderResultsList();
      });
      loadMoreBtn.hidden = true;
    }

    root.querySelectorAll('[data-mf-cat]').forEach(function (tile) {
      tile.addEventListener('click', function (event) {
        var manualType = tile.getAttribute('data-mf-type');
        if (!manualType) return;
        if (tile.tagName === 'A') event.preventDefault();
        if (typeSelect) typeSelect.value = manualType;
        var manuals = filterManuals({ manualType: manualType });
        showResults(
          manuals,
          manualTypeLabel(manualType) +
            ' — ' +
            manuals.length +
            ' manual' +
            (manuals.length === 1 ? '' : 's')
        );
      });
    });

    root.querySelectorAll('[data-mf-brand-filter]').forEach(function (el) {
      el.addEventListener('click', function (event) {
        var brand = el.getAttribute('data-mf-brand-filter');
        if (!brand) return;
        if (el.tagName === 'A') event.preventDefault();
        if (brandSelect) {
          brandSelect.value = brand;
          syncModelsForBrand(brand);
        }
        var manuals = filterManuals({ brand: brand });
        showResults(
          manuals,
          brand + ' — ' + manuals.length + ' manual' + (manuals.length === 1 ? '' : 's')
        );
        scrollToSearch();
      });
    });

    if (browseBtn) {
      browseBtn.addEventListener('click', function () {
        var target = root.querySelector('#tcb-mf-categories');
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    if (featuredNext && featuredTrack) {
      featuredNext.addEventListener('click', function () {
        featuredTrack.scrollBy({
          left: featuredTrack.clientWidth * 0.85,
          behavior: 'smooth'
        });
      });
    }

    if (featuredTrack) {
      var featured = (data.manuals || [])
        .filter(function (manual) {
          return manual.featured;
        })
        .slice(0, FEATURED_LIMIT);
      featuredTrack.innerHTML = featured.length
        ? featured.map(buildFeaturedCard).join('')
        : '<p class="tcb-mf-featured__empty">Featured manuals coming soon.</p>';
    }

    hideResults();
  }

  function boot() {
    var root = document.querySelector('[data-tcb-manual-finder-hub]');
    if (!root) return;
    var url = window.TCB_MANUAL_FINDER_DATA_URL;
    if (!url) {
      init(root);
      return;
    }
    fetch(url)
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        window.TCB_MANUAL_FINDER_DATA = data;
        init(root);
      })
      .catch(function () {
        init(root);
      });
  }

  document.addEventListener('DOMContentLoaded', boot);
})();
